(() => {
    const getNav = () => {
        return document.querySelector(".register .nav");
    }

    const isMobile = () => {
        return window.matchMedia("only screen and (max-width: 720px) and (orientation: portrait), only screen and (max-width: 860px) and (orientation: landscape)").matches;
    }

    const handleClick = (current) => {
        if(!isMobile()) return;

        const nav = current.closest(".nav");
        if(!nav) return;

        nav.classList.toggle("open");
    };

    const init = () => {
        const nav = getNav();
        if(!nav) return;

        const current = nav.querySelector(".is-current");
        current.style.gridRow = "1";
        current.addEventListener("click", () => handleClick(current))
    };

    document.addEventListener("DOMContentLoaded", init);
})();
(() => {
    
    const handleClick = (clicked) => {
        var summary = clicked.closest(".summary");
        if(!summary) return;
        
        summary.classList.toggle("open");
    };
    
    const init = () => {
        const h2s = document.querySelectorAll(".summary h2");
        if(!h2s) return;
        
        for(let h2 of h2s) {
            h2.addEventListener("click", () => handleClick(h2));
        }
    };
    
    document.addEventListener("DOMContentLoaded", init);
    
})();


//iffy
(() => {

    const handleClick = (clicked) => {
        var dataSelector = clicked.getAttribute("data-selector");
        var dataToggleAction = clicked.getAttribute("data-toggle-action");
        var validationSelector = clicked.getAttribute("data-toggle-validation");
        if (!dataSelector) return;

        if (validationSelector) {
            var valid = clicked.matches(validationSelector);
            if (!valid) return;
        }

        var toggleElement = document.querySelector(dataSelector);
        if (dataToggleAction) {
            if (dataToggleAction === "hide")
            {
                if (!toggleElement.classList.contains("hide")) {
                    toggleElement.classList.add("hide");
                }                
            }
            if (dataToggleAction === "show")
            {
                if (toggleElement.classList.contains("hide")) {
                    toggleElement.classList.remove("hide");
                }                
            }
        }
        else {
            toggleElement.classList.toggle("hide");
        }
    };

    const init = () => {
        const elements = document.querySelectorAll(".toggleSelector");
        if (!elements) return;

        for (let element of elements) {
            element.addEventListener("click", () => handleClick(element));
        }
    };

    document.addEventListener("DOMContentLoaded", init);
})();